import { Sparkles } from 'lucide-react';

export interface SmartSummaryBlockProps {
  summary: string;
  className?: string;
}

export function SmartSummaryBlock({
  summary,
  className = '',
}: SmartSummaryBlockProps) {
  return (
    <div
      className={[
        'bg-primary-light border border-primary-light-border rounded-xl p-3',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="flex items-center gap-1.5 mb-1.5">
        <Sparkles
          size={12}
          className="text-primary"
        />
        <span className="text-[10px] font-semibold uppercase tracking-wider text-primary">
          Smart Summary
        </span>
      </div>
      <p className="text-sm text-text-body leading-relaxed m-0 break-words">
        {summary}
      </p>
    </div>
  );
}
